<template>
  <v-container grid-list-md class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 lg3 v-for="(device, $index) in devices" :key="$index">
        <v-card elevation="0" color="accent" class="white--text" :to="{ name: 'device-detail' , params: { id: device.id } }">
          <v-card-title primary-title>
            <div>
              <div class="headline">{{ device.name }}</div>
              <p>{{ device.code }}</p>
              <p>{{ device.url }}</p>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import api from '@/api/app'
export default {
  name: 'DeviceList',
  mounted () {
    return api.getDevices().then(response => {
      this.devices = response
    })
  },
  data () {
    return {
      devices: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/DeviceList.vue